import { render, staticRenderFns } from "./FilesAdmin.vue?vue&type=template&id=0d034b2c&scoped=true"
import script from "./FilesAdmin.vue?vue&type=script&lang=js"
export * from "./FilesAdmin.vue?vue&type=script&lang=js"
import style0 from "./FilesAdmin.vue?vue&type=style&index=0&id=0d034b2c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d034b2c",
  null
  
)

export default component.exports